import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/app/src/components/forms/ForgotPasswordForm/index.tsx");
